import Vue from 'vue';
import VuexMixin from '@/mixins/vuex.mixin';

Vue.mixin(VuexMixin);